import {
  CButton,
  CFormSelect,
  CFormSwitch,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormInput,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import EmailQuotaService from 'src/service/EmailQuotaService'

const FantasyRoundResultEmail = (props) => {
  const [visible, setVisible] = useState(false)
  const [testEmail, setTestEmail] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSendTestEmail = () => {
    if (!testEmail) {
      ToastComponent('Please enter an email address', 'error')
      return
    }
    const data = { testEmail }
    setLoading(true)
    EmailQuotaService.testFantasyRoundReminderAfterOneDay(data).then((res) => {
      setLoading(false)
      ToastComponent(res.message, res.success ? 'success' : 'error')
      if (res.success) {
        setVisible(false)
        setTestEmail('')
      }
    })
  }

  const [confirmVisible, setConfirmVisible] = useState(false)
  const [confirmType, setConfirmType] = useState(null)
  const [pendingValue, setPendingValue] = useState('')
  const [pendingSwitchValue, setPendingSwitchValue] = useState(null)

  const changeNotificationHour = (e) => {
    setPendingValue(e.target.value)
    setConfirmType('hour')
    setConfirmVisible(true)
  }

  const changeNotificationSwitch = (e) => {
    const newValue = e.target.checked // true = enable, false = disable

    // If attempting to enable when duration is not set > 0
    if (newValue === true && (!props.hourValue['50'] || props.hourValue['50'] === '0')) {
      ToastComponent('Please set a notification time before enabling this reminder.', 'error')
      return
    }

    setPendingSwitchValue(newValue)
    setConfirmType('switch')
    setConfirmVisible(true)
  }

  const confirmChange = () => {
    if (confirmType === 'hour') {
      // Update UI for hour
      props.handleHourChange({ target: { value: pendingValue } }, '50')

      const durationObj = {}
      durationObj[50] = pendingValue

      // ✅ Auto-disable if hour is 0 or empty
      if (!pendingValue || pendingValue === '0') {
        // Turn OFF switch
        props.handleEnableDisableChangeStatus({ target: { checked: false } }, '50')

        // Save both hour + disable
        props.handleSaveEmailNotificationSettingUpdated(50, durationObj)
        setConfirmVisible(false)
        return
      }

      // Normal save
      props.handleSaveEmailNotificationSettingUpdated(50, durationObj)
    }

    if (confirmType === 'switch') {
      // Update UI toggle
      props.handleEnableDisableChangeStatus({ target: { checked: pendingSwitchValue } }, '50')

      // Save using latest hour value
      const durationObj = {}
      durationObj[50] = props.hourValue['50']

      props.handleSaveEmailNotificationSettingUpdated(50, durationObj)
    }

    setConfirmVisible(false)
  }

  return (
    <>
      <table className="main-table table innertable">
        <thead>
          <tr>
            <th width="30%">Name</th>
            <th width="30%">Duration</th>
            <th width="20%">Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Fantasy Round Results & Reminder</td>
            <td>
              <CFormSelect
                className="form-control"
                value={props.hourValue['50']}
                onChange={changeNotificationHour}
              >
                <option value="">Set Hours (After End of Round)</option>
                {[...Array(24).keys()].map((num) => (
                  <option key={num + 1} value={num + 1}>
                    {num + 1}
                  </option>
                ))}
              </CFormSelect>
            </td>
            <td>
              <CFormSwitch
                size="lg"
                label={props.enableDisableStatus['50'] ? 'Enabled' : 'Disabled'}
                checked={props.enableDisableStatus['50'] || false}
                onChange={changeNotificationSwitch}
              />
            </td>
            <td className="d-flex gap-2">
              <CButton color="info" onClick={() => setVisible(true)}>
                Test Email
              </CButton>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Test Email Modal */}
      <CModal visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Send Test Email</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CFormInput
            type="email"
            placeholder="Enter test email address"
            value={testEmail}
            onChange={(e) => setTestEmail(e.target.value)}
          />
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleSendTestEmail} disabled={loading}>
            {loading ? 'Sending...' : 'Send'}
          </CButton>
        </CModalFooter>
      </CModal>

      {/* Confirmation Modal */}
      <CModal visible={confirmVisible} onClose={() => setConfirmVisible(false)}>
        <CModalHeader>
          <CModalTitle>Confirm Change</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {confirmType === 'hour' && (
            <>
              Are you sure you want to set this reminder to {pendingValue} hour(s) after the round
              ends?
            </>
          )}

          {confirmType === 'switch' && (
            <>
              Are you sure you want to {pendingSwitchValue ? 'Enable' : 'Disable'} this
              notification?
            </>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setConfirmVisible(false)}>
            Cancel
          </CButton>
          <CButton color="primary" onClick={confirmChange}>
            Confirm
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default FantasyRoundResultEmail
